import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl } from '@angular/forms';
import { Title } from '@angular/platform-browser';
import { NavController } from '@ionic/angular';
import { ReturnNativeService } from '../../../shared/service/comunicator-native/return-native/return-native';
import { FormValidations } from '../../../shared/form-validation/form-validation';
import { DefaultPageComponent } from '../../../shared/page/default-page.component';
import { BackNativeService } from '../../../shared/service/comunicator-native/back-native/back-native';
import { JourneyService } from '../../../shared/service/journey/journey.service';
import { AddressService } from '../../services/address.service';
import { AnalycticsNativeService } from '../../../shared/service/comunicator-native/analytics-native/analyctics-native';
import { TrackInfo } from 'src/app/shared/service/journey/tracks/model/track-info';
import { AnalyticsPageModel } from '../../../shared/model/analyticsPage';
import { AnalyticsPageService } from '../../../shared/service/analytics/analytics-page.service';

@Component({
  selector: 'app-district',
  templateUrl: './district.page.html',
  styleUrls: ['./district.page.scss'],
})
export class DistrictPageComponent extends DefaultPageComponent implements OnInit {

  public name = '';
  public idComponentDistrict = 'address-district';
  placeholder = '';
  error = false;
  buttonEnable = false;
  textError = '';
  invalidErrorText = 'Nome inválido';
  idLabel = 'address-district';
  label = 'nome do bairro';
  headerId = 'district';
  titlePage = 'Endereço';
  startStage = '';
  endStage = '';
  analyticsPage: AnalyticsPageModel;

  addressDistrictForm = this.formBuilder.group({
    districtAddress: this.formBuilder.control('', [FormValidations.validationsNameAddress])
  });

  constructor(private formBuilder: FormBuilder,
              public router: NavController,
              public backNativeService: BackNativeService,
              private addressService: AddressService,
              private title: Title,
              public journeyService: JourneyService,
              public returnNativeService: ReturnNativeService,
              public analycticsNativeService: AnalycticsNativeService,
              private analyticsPageService: AnalyticsPageService,
              ) {
                super(backNativeService, journeyService, router, returnNativeService);
                this.getAnalyticsPage();
                this.analyticsData();
                this.getTrack();
               }

  ngOnInit() {
    this.setTitle();
    this.headerFocus();
    this.editFieldInvest('bairro', 'district', 'address');
  }

  getAnalyticsPage() {
    this.analyticsPage = this.analyticsPageService.setAnalyticsPage();
  }

  getTrack() {
    const track = this.journeyService.selectedTrack;
    const path = 'address';

    this.startStage = track.getIndexPage(this.headerId, path).toString();
    this.endStage = track.getTotalPage(path).toString();
  }

  ionViewWillEnter() {
    this.headerFocus();
    this.setEditPageRegistratio();
  }

  ionViewDidLeave() {
    this.ariaHidden = true;
  }

  analyticsData() {
    const it_pagename = this.analyticsPage.addressDistrict;
    this.analycticsNativeService.analyticsTrackStateCommunicator(it_pagename);
  }

  setTitle() {
    this.title.setTitle(this.titlePage);
  }

  errorMessage() {
    const control = this.addressDistrictForm.get('districtAddress') as FormControl;
    this.error = control.errors !== null || control.value < 0;

    this.error ? this.buttonEnable = false : this.buttonEnable = true;

    if (control.errors !== null && control.errors.hasOwnProperty('repeated')) {
      this.textError = this.invalidErrorText;
    }
    if (control.errors !== null && control.errors.hasOwnProperty('nameSpace')) {
      this.textError = this.invalidErrorText;
    }
  }

  clickNext() {
    this.addressService.setAddressDistrict(this.name);

    if (!this.addressService.addressInitalPostCode?.state) {
      return this.nextPage();
    }

    if (!this.addressService.addressInitalPostCode?.city) {
      return this.router.navigateForward(['address', 'city']);
    }

    if (this.addressService.addressInitalPostCode?.state
      && this.addressService.addressInitalPostCode?.city) {
      const track = this.journeyService.selectedTrack.getTrack();
      const indexAdressState = track.findIndex((page: TrackInfo) => page.pageId === 'address-city') + 1;
      const path = track[indexAdressState]?.path;

      if (path) {
        return this.router.navigateForward(path);
      } else {
        return this.endJourney();
      }
    }
  }

  analyticsEventClique() {
    const it_eventcategory = 'Clique';
    const it_complementary = { 
              it_eventaction: this.analyticsPage.action,
              it_eventlabel: this.analyticsPage.back,
              it_pagename: this.analyticsPage.addressDistrict
            };
    this.analycticsNativeService.analyticsTrackActionCommunicator(it_eventcategory, it_complementary);
  }

  getPageId(): string {
    return this.headerId;
  }
  
  setEditPageRegistratio() {
    if (this.journeyService.registratioJourney.data.address.district) {
      this.name = this.journeyService.registratioJourney.data.address.district;
      this.addressDistrictForm.controls.districtAddress.setValue(this.journeyService.registratioJourney.data.address.district);
      this.errorMessage();
    }
  }

  submitForm($event: any) {
    $event.preventDefault();
    return false;
  }

  backPage() {
    this.analyticsEventClique();
    this.back();
  }
  
}
